import { render, staticRenderFns } from "./CreateKasbonDriver.vue?vue&type=template&id=876a87d2"
import script from "./CreateKasbonDriver.vue?vue&type=script&lang=js"
export * from "./CreateKasbonDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports